module.exports = __webpack_public_path__ + "static/media/icon-profile.0039ca34.svg";